import ls from '../utils/localStorage'
import store from '../store'
import * as mutations from '@store/_mutations'

export default async (to, from, next) => {
    let theState = ls.get()

    if (!!theState) {
        store.commit(mutations.SET_STATE, theState)
    }

    let isAuthenticated = store.getters.isAuthenticated
    if (isAuthenticated) return next()

    return next({
        name: 'login',
    })
}
